import { UpdateVoiceCloneInput, UserVoice } from "@next-platform/client-common-core";

export enum VoiceFormFields {
  VOICE_NAME = "name",
  DESCRIPTION = "description",
  LANGUAGE = "language",
  VOICE_CLIP = "voiceClip",
  PLACEHOLDER_CLIP = "placeholderVoiceClip",
}

export const VOICE_CLIP_DURATION_ERROR = {
  NONE: "NONE",
  TOO_SHORT: "TOO_SHORT",
  TOO_LONG: "TOO_LONG",
} as const;

export type VoiceClipDurationError = (typeof VOICE_CLIP_DURATION_ERROR)[keyof typeof VOICE_CLIP_DURATION_ERROR];

export type VoiceClipPlaceholder = NonNullable<UserVoice["sample_audio_files"]>[number];

export type VoiceFormPayload = {
  name: string;
  description: string;
  language?: UpdateVoiceCloneInput["language"];
  sampleFiles: NonNullable<UpdateVoiceCloneInput["sampleFiles"]>;
};

export type VoiceFormProps = {
  id?: string;
  name?: string;
  description?: string;
  language?: string;
  voiceClip?: File[];
  voiceClipPlaceholders?: VoiceClipPlaceholder[];
  onClone?: (voice: VoiceFormPayload) => Promise<{ success: boolean; error: string }>;
  setShowAlert?(newValue: boolean): void;
};
